import { LaneType } from 'common-types';
import { AddressType } from '../AddressType';
import { SupportedLocaleEnum } from 'localization';
import { ChannelDataType } from './WorkflowTypes';

export enum EmailTemplateEnum {
  ChannelInvite = 'ChannelInvite',
  CompleteSignup = 'CompleteSignup',
  ContentNotification = 'ContentNotification',
  ForgotPassword = 'ForgotPassword',
  PasswordChanged = 'PasswordChanged',
  UserContentInteractionReceipt = 'UserContentInteractionReceipt',
  UserContentInteractionStatusChange = 'UserContentInteractionStatusChange',
  UserDeactivated = 'UserDeactivated',
  UserVerification = 'UserVerification',
  UserHIDCredential = 'UserHIDCredential',
  ShopifyBurstUserHIDInvitation = 'ShopifyBurstUserHIDInvitation',
}

export type SendEmailType = {
  from: string;
  to: string;
  replyTo?: string;
  subject: string;
  text: string;
  html: string;
  attachments?: AttachmentType[];
  tags?: SesTagType[];
  bcc?: string[];
  cc?: string[];
  notificationCategory?: string;
  metadata?: Record<string, unknown>;
  batchId?: string;
  trackLinks?: { baseUrl: string };
  notificationOriginMetadata?: NotificationOriginMetadata;
  /**
   * A stable id for one logical send: sending the same id again does not send a second email.
   * Needs the `EmailSendByTemporal` flag on and debug mode off: `sendEmail` throws otherwise.
   */
  emailId?: string;
};

/** The system that requested an email; the dispatch status of that email is reported back to it. */
export enum NotificationFeedbackSource {
  VisitorManagement = 'VISITOR_MANAGEMENT',
}

/** The domain that requested an email, and its own id for the notification. */
export type NotificationOriginMetadata = {
  source: NotificationFeedbackSource;
  externalNotificationIntentId: string;
};

export type SesTagType = {
  Name: string;
  Value: string;
};

export type AttachmentType = {
  filename: string;
} & ({ content: Buffer; path?: never } | { path: string; content?: never });

export type EmailResponseType = {
  response: string;
  /** The notification record a send created; only present when the send had an `emailId`. */
  notificationIntentId?: string;
};

export type ChannelProfileType = {
  _id: LaneType.UUID;
  name: string | null;
  email: LaneType.Email | null;
};

export type UserVerifyDataType = {
  _id: string;
  _created: Date;
  profileName: string;
  email: string;
  locale: string;
  unsubscribe: string;
  loginVerify: string;
  loginId: string;
  loginKey: string;
};

export type ChannelInviteDataType = {
  _id: LaneType.UUID;
  _created: Date;
  inviteName: string;
  inviteEmail: LaneType.Email;
  sentById: string;
  sentByName: string;
  locale: string;
  address: AddressType;
  channel: ChannelDataType;
  profile: ChannelProfileType;
  companyName?: string;
};

export type CompleteSignupUserDataType = {
  name: string;
  guid: string;
  verify: string;
  locale: string;
  channelName?: string;
  companyName?: string;
  address: AddressType;
  channel: ChannelDataType;
};

export type UserHIDCredentialDataType = {
  profile: {
    _id: string;
    name: string;
  };
};

export type ShopifyBurstUserHIDInvitationType = {
  _id: LaneType.UUID;
  locale: SupportedLocaleEnum;
  profile: {
    _id: string;
    name: string;
  };
};
